import { Link, useLocation } from "react-router-dom";
import logo from "../assets/Mallas imagen/logo-pinguino(relleno-vacio).png";
import { ShoppingCart } from "lucide-react"; // si usás Lucide o Heroicons
import { useEffect, useState, useRef } from 'react';
import { useCarrito } from "../context/CarritoContext";

export default function Navbar() {
  const location = useLocation();
  const { carrito, openCart } = useCarrito();

  // Blanco apenas el primer píxel del header deja de estar sobre la imagen
  const [scrolled, setScrolled] = useState(false);

  const TOPBAR_H = 40;
  const [topOffset, setTopOffset] = useState(TOPBAR_H);

  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  const navRef = useRef(null);

  // ⬇️ NUEVO: refs para marquee infinito
  const marqueeOuterRef = useRef(null);
  const marqueeInnerRef = useRef(null);
  const marqueeTrackRef = useRef(null);

  const isHeroRoute =
    location.pathname === "/" || location.pathname.startsWith("/productos");

  const textColorClass = isHeroRoute
    ? (scrolled ? "text-black" : "text-white")
    : "text-black";

  // ⬇️ NUEVO: velocidad del marquee en píxeles/segundo (ajustá a gusto)
  const PX_PER_SECOND = 70;

  // ⬇️ NUEVO: calcula ancho del track y fija duración para un loop perfecto
  useEffect(() => {
    const setDuration = () => {
      const inner = marqueeInnerRef.current;
      const track = marqueeTrackRef.current;
      if (!inner || !track) return;

      // ancho de UN set de mensajes
      const trackWidth = track.scrollWidth;

      // duración = distancia / velocidad
      const seconds = trackWidth / PX_PER_SECOND;

      // seteamos variables CSS en el elemento animado
      inner.style.setProperty("--track-w", `${trackWidth}px`);
      inner.style.setProperty("--ticker-seconds", `${seconds}s`);
    };

    setDuration();
    window.addEventListener("resize", setDuration);
    return () => window.removeEventListener("resize", setDuration);
  }, []);

  // Bloquear scroll cuando abre el panel
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  // Cerrar con Escape
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Cerrar al click fuera
  useEffect(() => {
    const onClickOutside = (e) => {
      if (open && panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  // Cerrar menú al cambiar de ruta
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Scroll handler ÚNICO
  useEffect(() => {
    const getHeroBoundary = () => {
      const sentinel =
        document.getElementById("nav-sentinel") ||
        document.getElementById("hero-end");
      const hero =
        document.getElementById("hero") ||
        document.getElementById("productos-hero");
      if (sentinel?.getBoundingClientRect) return sentinel.getBoundingClientRect().top;
      if (hero?.getBoundingClientRect) return hero.getBoundingClientRect().bottom;
      return Number.POSITIVE_INFINITY;
    };

    const onScrollOrResize = () => {
      const y = window.scrollY;

      let visible = Math.max(TOPBAR_H - y, 0);
      if (visible < 4) visible = 0;
      if (visible > TOPBAR_H - 2) visible = TOPBAR_H;
      setTopOffset(visible);

      if (isHeroRoute) {
        const heroBoundaryY = getHeroBoundary();
        const navEl = navRef.current;
        const navH = navEl ? navEl.getBoundingClientRect().height : 0;
        const headerBottom = visible + navH;
        setScrolled(heroBoundaryY <= headerBottom);
      } else {
        setScrolled(y > 50);
      }
    };

    onScrollOrResize();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    return () => {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [isHeroRoute, location.pathname]);

  return (
    <>
      {/* Topbar (misma altura/clases; marquee infinito sin cortes) */}
      <div
        ref={marqueeOuterRef}
        className="w-full bg-[#ffae00] text-gray-800 text-center text-sm py-2 overflow-hidden"
      >
        {/* Contenedor animado que incluye DOS copias del track */}
        <div
          ref={marqueeInnerRef}
          className="flex items-center will-change-transform wet-marquee"
        >
          {/* Track 1: mensajes */}
          <div
            ref={marqueeTrackRef}
            className="flex items-center whitespace-nowrap"
          >
            <span className="mx-4 prueba text-[12px]"><strong>Envío gratis a todo el pais</strong> </span> 
            <span className="mx-4 prueba text-[12px]"><strong>15% OFF en transferencia</strong></span>
            <span className="mx-4 prueba text-[12px]"><strong>3 cuotas sin interés</strong></span>
          </div>

          {/* Track 2: la MISMA secuencia, pegada a la primera (para loop perfecto) */}
          <div
            aria-hidden="true"
            className="flex items-center whitespace-nowrap"
          >
            <span className="mx-4 prueba text-[12px]"><strong>Envío gratis a todo el pais</strong></span>
            <span className="mx-4 prueba text-[12px]">  <strong>15% OFF en transferencia</strong></span>
            <span className="mx-4 prueba text-[12px]"><strong>3 cuotas sin interés</strong></span>
          </div>
        </div>
      </div>

      {/* Header */}
      <nav
        ref={navRef}
        style={{
          top: `${topOffset}px`,
          transition: "top 280ms ease-out",
          willChange: "top",
        }}
        className={`fixed left-0 w-full z-50 transition-colors duration-300 ease-out ${
          scrolled ? "bg-white" : "bg-transparent"
        }`}
      >
        <div className="mx-auto w-full max-w-[92%] sm:max-w-[90%] md:max-w-6xl px-4 md:px-6">
          <div className="h-6 md:h-8" />

          {/* Navbar */}
          <div className="relative flex items-center pt-4 pb-4 md:pt-6 md:pb-6">
            {/* IZQUIERDA */}
            <div className="flex items-center text-sm ml-1 sm:ml-2 md:ml-10">
              <div className="hidden md:flex space-x-8">
                <Link to="/" className={`hover:underline nav-onepalm ${textColorClass} hidden md:inline`}>Inicio</Link>
                <Link to="/productos" className={`hover:underline nav-onepalm ${textColorClass} hidden md:inline`}>Productos</Link>
              </div>

              {/* Hamburguesa (mobile) */}
              <button
                onClick={() => setOpen(true)}
                aria-label="Abrir menú"
                aria-expanded={open}
                className={`md:hidden p-2 rounded-lg border/0 ${textColorClass}`}
              >
                <span className={`block w-6 h-0.5 mb-1 ${textColorClass === "text-black" ? "bg-black" : "bg-white"}`} />
                <span className={`block w-6 h-0.5 mb-1 ${textColorClass === "text-black" ? "bg-black" : "bg-white"}`} />
                <span className={`block w-6 h-0.5 ${textColorClass === "text-black" ? "bg-black" : "bg-white"}`} />
              </button>
            </div>

            {/* LOGO centrado */}
            <div className="absolute left-1/2 top-1/2 md:top-[70%] -translate-x-1/2 -translate-y-1/2 z-40">
              <Link to="/" aria-label="Ir a Inicio" title="Inicio" className="inline-block focus:outline-none">
                <img src={logo} alt="Logo" className="h-24 md:h-[180px] w-auto select-none" />
              </Link>
            </div>

            {/* DERECHA */}
            <div className="flex items-center relative ml-auto mr-2 md:mr-10 gap-6">
              {/* Link Contacto: SOLO DESKTOP */}
              <Link
                to="/contacto"
                className={`hover:underline nav-onepalm text-sm ${textColorClass} hidden md:inline`}
              >
                Contacto & FAQ's
              </Link>

              {/* Carrito (visible en mobile y desktop) */}
              <button
                onClick={openCart}
                className={`hover:underline relative ${textColorClass}`}
                style={{ top: "-2px" }}
                aria-label="Abrir carrito"
              >
                <ShoppingCart className="h-6 w-6" />
                {carrito.length > 0 && (
                  <span
                    aria-live="polite"
                    className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full"
                  >
                    {carrito.length}
                  </span>
                )}
              </button>
            </div>
          </div>

          <div className="h-2 md:h-3" />
          <div className="border-b border-gray-400" />
        </div>

        {/* Panel lateral (mobile) — SOLO MODIFICACIÓN: paneo tipo CartDrawer */}
        <div className={`fixed inset-0 z-[70] md:hidden ${open ? "" : "pointer-events-none"}`}>
          {/* Overlay con fade */}
          <div
            className={`absolute inset-0 bg-black/40 transition-opacity duration-200 ${open ? "opacity-100" : "opacity-0"}`}
            onClick={() => setOpen(false)}
          />
          {/* Aside con slide y ease-out como CartDrawer (pero desde la izquierda) */}
          <aside
            ref={panelRef}
            role="dialog"
            aria-modal="true"
            className={`absolute left-0 top-0 h-full w-72 max-w-[80%] bg-white shadow-xl
                        transition-transform duration-300 ease-out
                        ${open ? "translate-x-0" : "-translate-x-full"}`}
          >
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <span className="text-[13px] nav-onepalm">Menú</span>
              <button
                onClick={() => setOpen(false)}
                aria-label="Cerrar menú"
                className="p-2 rounded-lg border"
              >
                <div className="relative w-4 h-4">
                  <span className="absolute inset-0 rotate-45 block w-4 h-0.5 bg-black top-1/2 -translate-y-1/2" />
                  <span className="absolute inset-0 -rotate-45 block w-4 h-0.5 bg-black top-1/2 -translate-y-1/2" />
                </div>
              </button>
            </div>

            <ul className="p-2">
              <li>
                <Link to="/" onClick={() => setOpen(false)} className="block px-4 py-3 text-[13px] nav-onepalm hover:bg-gray-50 rounded-md text-gray-900">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/productos" onClick={() => setOpen(false)} className="block px-4 py-3 text-[13px] nav-onepalm hover:bg-gray-50 rounded-md text-gray-900">
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/contacto" onClick={() => setOpen(false)} className="block px-4 py-3 text-[13px] nav-onepalm hover:bg-gray-50 rounded-md text-gray-900">
                  Contacto & FAQ's
                </Link>
              </li>
            </ul>
          </aside>
        </div>
      </nav>

      {/* ⬇️ NUEVO: estilos del marquee infinito */}
      <style>{`
        /* La animación mueve DOS tracks pegados de izquierda a derecha,
           y una vuelta termina justo cuando el segundo track reemplaza al primero. */
        @keyframes wet-marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(calc(-1 * var(--track-w))); }
        }
        .wet-marquee {
          /* la duración real viene de --ticker-seconds (set por JS),
             calculada como anchoTrack / pxPorSegundo */
          animation: wet-marquee var(--ticker-seconds, 20s) linear infinite;
        }
        .wet-marquee:hover { animation-play-state: paused; }
        @media (prefers-reduced-motion: reduce) { .wet-marquee { animation: none; } }
      `}</style>
    </>
  );
}



